import PropTypes from 'prop-types';
import { memo } from 'react';
// @mui
import { Stack } from '@mui/material';
//
// eslint-disable-next-line import/no-cycle
import { NavListRoot } from './NavList';
// ----------------------------------------------------------------------
const hideScrollbar = {
  msOverflowStyle: 'none',
  scrollbarWidth: 'none',
  overflowY: 'scroll',
  '&::-webkit-scrollbar': {
    display: 'none'
  }
};

const NavSectionHorizontal = ({ navConfig }) => (
  <Stack direction="row" justifyContent="center" sx={{ bgcolor: 'background.neutral', borderRadius: 1, px: 0.5 }}>
    <Stack direction="row" sx={{ ...hideScrollbar, py: 1 }}>
      {navConfig.map((group) => (
        <Stack key={group.subheader} direction="row" flexShrink={0}>
          {group.items.map((list) => (
            <NavListRoot key={list.title + list.path} list={list} />
          ))}
        </Stack>
      ))}
    </Stack>
  </Stack>
);

export default memo(NavSectionHorizontal);

NavSectionHorizontal.propTypes = {
  navConfig: PropTypes.array
};

NavSectionHorizontal.defaultProps = {
  navConfig: []
};
